import React from 'react';
import classNames from 'classnames';
import { useDetectTextOverflow } from 'application/hooks';
import VideoMediafilePoster from 'application/components/VideoMediafileItemPoster';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import Text from '@zvuk-b2b/react-uikit/ui/Text';

import styles from './index.module.scss';
import { TEXTS } from '../texts';
import { isVideoMediafile } from '../utils';

export interface VideoMediafilePreviewItemContentProps {
  isCompact?: boolean;
  title?: string | null;
  duration?: number | null;
  imgLink?: string | null;
  uploading?: boolean;
  actionText?: string;
  actionHandler?: () => void;
  extension?: string | null;
  error?: string | Error | null;
  url?: string;
  posterContainerClassName?: string;
  posterClassName?: string;
}

const VideoMediafilePreviewItemContent: React.FC<VideoMediafilePreviewItemContentProps> = ({
  isCompact,
  title,
  duration,
  imgLink,
  uploading,
  actionText,
  actionHandler,
  extension,
  error,
  url,
  posterContainerClassName,
  posterClassName,
}) => {
  const descriptionText = uploading ? TEXTS.UPLOADING : undefined;

  const { isOverflow, textRef } = useDetectTextOverflow('[data-testid="video_media_title"]');

  return (
    <div className={classNames(styles.content, { [styles.contentCompact]: isCompact })}>
      <div className={styles.poster}>
        <VideoMediafilePoster
          title={title}
          link={imgLink}
          uploading={uploading}
          duration={duration}
          extension={extension}
          url={url}
          isVideo={isVideoMediafile(extension)}
          withPreview={Boolean(url)}
          containerClassName={posterContainerClassName}
          posterClassName={posterClassName}
        />
      </div>

      <div
        ref={textRef}
        className={styles.container}>
        <Popper
          placement={HintPlacement.PLACEMENT_TOP_START}
          containerClassName={styles.popper}
          isShow={isOverflow}
          offset={[10, 10]}
          triggerNode={
            <span
              data-testid="video_media_title"
              className={styles.title}>
              {title}
            </span>
          }>
          {title}
        </Popper>

        {descriptionText && <p className={styles.description}>{descriptionText}</p>}
        {actionText && (
          <Button
            className={styles.actionButton}
            elementId="video_media_action"
            type={ButtonType.PLAIN}
            onClick={actionHandler}>
            {actionText}
          </Button>
        )}

        {error && (
          <Text
            elementId="video_stream_error"
            className={styles.error}>
            {TEXTS.ERROR}
          </Text>
        )}
      </div>
    </div>
  );
};

export default VideoMediafilePreviewItemContent;
